import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./components/Notification/Notification.css";
import "./App.css";

import { Web3Provider } from "./context/Web3Context";
import TopNavbar from "./components/TopNavbar/TopNavbar";
import BottomTabBar from "./components/BottomTabBar/BottomTabBar";
import RainBackground from "./components/RainBackground/RainBackground";

import Welcome from "./pages/Home/Home";
import Register from "./pages/Register/Register";
import HomeTab from "./pages/HomeTab/HomeTab";
import StarTab from "./pages/StarTab/StarTab";
import GlobalTab from "./pages/GlobalTab/GlobalTab";
import ReportsTab from "./pages/ReportsTab/ReportsTab";
import Admin from "./pages/Admin/Admin";

function App() {
  return (
    <Web3Provider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="app">
          {/* Rain animation hidden temporarily - keep for future use */}
          {/* <RainBackground /> */}
          <TopNavbar />

          <main className="app-main">
            <Routes>
              <Route path="/" element={<Welcome />} />
              <Route path="/register" element={<Register />} />
              <Route path="/home" element={<HomeTab />} />
              <Route path="/star" element={<StarTab />} />
              <Route path="/global" element={<GlobalTab />} />
              <Route path="/reports" element={<ReportsTab />} />
              <Route path="/admin" element={<Admin />} />
              {/* Legacy redirects */}
              <Route path="/dashboard" element={<Navigate to="/home" replace />} />
              <Route path="/plan1" element={<Navigate to="/star" replace />} />
              <Route path="/plan2" element={<Navigate to="/global" replace />} />
              <Route path="/activity" element={<Navigate to="/reports" replace />} />
              <Route path="/claim" element={<Navigate to="/home" replace />} />
              <Route path="/team" element={<Navigate to="/star" replace />} />
            </Routes>
          </main>

          <BottomTabBar />

          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            theme="dark"
          />
        </div>
      </BrowserRouter>
    </Web3Provider>
  );
}

export default App;
